import { useI18n } from "../i18n/I18nContext";
import { useSiteContent } from "../context/SiteContentContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t, lang } = useI18n();
  const { content } = useSiteContent();
  const c = (key) => content[key]?.[lang] || content[key]?.en || "";
  const termsHref = lang === "fi" ? "/toimitusehdot" : "/terms";
  const contactHref = lang === "fi" ? "/yhteystiedot" : "/contact";
  const termsLabel = lang === "fi" ? "Toimitusehdot" : lang === "sv" ? "Villkor" : "Terms";
  const contactLabel = lang === "fi" ? "Yhteystiedot" : lang === "sv" ? "Kontakt" : "Contact";

  return (
    <footer className="mt-32 border-t border-border/60 bg-[hsl(var(--teal-soft))]/40" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-hand text-5xl mb-4"><span className="text-[hsl(var(--primary))]">@</span>pikkurumiluksia</div>
          <div className="text-sm text-muted-foreground max-w-sm leading-relaxed space-y-0.5">
            <div>{c("business_name")}</div>
            <div>{c("business_address")}</div>
            <div className="text-xs mt-2">Y-tunnus: {c("business_id")}</div>
          </div>
        </div>
        <div>
          <div className="label-caps mb-4">{t("footer.studio")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="link-underline">{t("nav.shop")}</Link></li>
            <li><Link to="/story" className="link-underline">{t("nav.story")}</Link></li>
            <li><Link to={termsHref} className="link-underline" data-testid="footer-terms-link">{termsLabel}</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-caps mb-4">{t("footer.contact")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to={contactHref} className="link-underline" data-testid="footer-contact-link">{contactLabel}</Link></li>
            <li><a href={`mailto:${c("footer_email")}`} className="link-underline">{c("footer_email")}</a></li>
            <li>{c("footer_phone")}</li>
            <li><Link to="/admin" className="link-underline text-muted-foreground" data-testid="footer-admin-link">{t("nav.admin")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 text-xs text-muted-foreground flex flex-wrap gap-4">
          <span>© {new Date().getFullYear()} Pikkurumiluksia — {t("footer.rights")}</span>
          <span className="opacity-40">•</span>
          <Link to={termsHref} className="link-underline">{termsLabel}</Link>
          <span className="opacity-40">•</span>
          <Link to={contactHref} className="link-underline">{contactLabel}</Link>
        </div>
      </div>
    </footer>
  );
}
